import { useContext } from 'react';

import { IOrderContext, OrderContext, OrderFunction } from '../components/contexts/OrderContext';

export const useOrderContext = (): IOrderContext => {
  const context = useContext(OrderContext);

  if (!context) {
    throw new Error('useOrderContext must be used within an OrderContext.Provider');
  }

  return context;
};

// Helper hook for accessing dynamic functions
export const useOrderFunction = <T extends OrderFunction>(key: string): T | undefined => {
  const { useFunction } = useOrderContext();
  return useFunction<T>(key);
};
